import React from 'react';

/** Renders label text with a red trailing * for required fields (i18n or inline). */
export default function RequiredLabelText({ text, required = false }) {
  const value = String(text ?? '');

  if (value.endsWith(' *')) {
    return (
      <>
        {value.slice(0, -2)}
        <span className="qawaem-required-mark"> *</span>
      </>
    );
  }

  if (value.endsWith('*')) {
    return (
      <>
        {value.slice(0, -1)}
        <span className="qawaem-required-mark">*</span>
      </>
    );
  }

  if (required) {
    return (
      <>
        {value}
        <span className="qawaem-required-mark"> *</span>
      </>
    );
  }

  return value;
}
